import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Lifebuoy, Plus } from '@phosphor-icons/react';
import API from '../lib/api';
import { useAuth } from '../lib/auth';

const TYPES = ['Order issue', 'Payment', 'Print quality', 'Delivery', 'Other'];

const Support = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ type: TYPES[0], phone: user?.phone || '', message: '' });
  const [tickets, setTickets] = useState([]);

  const load = async () => {
    if (!user) return;
    try { const r = await API.get('/support/tickets/mine'); setTickets(r.data); } catch (e) { console.error('[support] load tickets failed', e); }
  };
  useEffect(() => { load(); }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    if (!user) { toast.error('Login to raise a ticket'); return; }
    try {
      await API.post('/support/tickets', form);
      toast.success('Ticket raised');
      setForm({ type: TYPES[0], phone: user.phone || '', message: '' });
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="p-6">
      <div className="reg-mark">
        <div className="text-[10px] tracking-[0.32em] uppercase font-bold" style={{ color: 'var(--pk-primary)' }}>— Support</div>
        <h1 className="font-display text-[26px] mt-2 leading-tight">How can we help?</h1>
      </div>

      <form onSubmit={submit} className="mt-5 pk-card p-4 space-y-3">
        <div>
          <label className="pk-label">Type</label>
          <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} className="pk-select" data-testid="support-type">
            {TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label className="pk-label">Phone</label>
          <input inputMode="numeric" pattern="[0-9]*" className="pk-input font-mono" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, '') })} required data-testid="support-phone" />
        </div>
        <div>
          <label className="pk-label">Message</label>
          <textarea rows={3} className="pk-textarea" value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required data-testid="support-message" />
        </div>
        <button className="pk-btn w-full" data-testid="support-submit"><Plus size={14}/> Raise ticket</button>
      </form>

      {tickets.length > 0 && (
        <div className="mt-5">
          <div className="text-[10px] tracking-[0.24em] uppercase font-bold mb-2">Your tickets</div>
          <div className="space-y-2">
            {tickets.map(t => (
              <div key={t.ticket_id} className="pk-card p-3">
                <div className="flex items-center justify-between">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">#{t.ticket_id.slice(-8)}</div>
                  <div className={`pk-chip text-[9px] ${t.status === 'open' ? 'active' : ''}`}>{t.status}</div>
                </div>
                <div className="font-bold text-[13px] mt-1">{t.type}</div>
                <div className="text-[12px] text-neutral-600 mt-1">{t.message}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Support;
